import { Platform } from '@angular/cdk/platform';
import { Component, Input, OnInit, inject } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AdminService } from '../../../admin/admin.service';
import { ReportingService } from '../../reporting.service';
import { FormControl } from '@angular/forms';
import { saveAs } from '@progress/kendo-file-saver';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-case-manager-reports',
  templateUrl: './case-manager-reports.component.html',
  styleUrl: './case-manager-reports.component.scss',
  standalone: false,
})
export class CaseManagerReportsComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private rptSvc = inject(ReportingService);
  private snacky = inject(MatSnackBar);

  @Input() baseUrl;
  @Input() ignoreUnitValidation = false;
  filteredUnits;
  unitsControlCurrent = new FormControl();
  selectedUnitCurrent;
  startDateCurrent;
  endDateCurrent;
  unitsControlHistorical = new FormControl();
  selectedUnitHistorical;
  startDateHistorical;
  endDateHistorical;
  unitsControlNotes = new FormControl();
  selectedUnitNotes;
  startDateNotes;
  endDateNotes;
  unitsControlAutoApproved = new FormControl();
  selectedUnitAutoApproved;
  startDateAutoApproved;
  endDateAutoApproved;
  loading = false;

  ngOnInit(): void {
    this.getUnits();
  }

  getUnits() {
    this.unitsControlCurrent.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
    this.unitsControlHistorical.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
    this.unitsControlNotes.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
    this.unitsControlAutoApproved.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  checkSelection(control) {
    if (!this.ignoreUnitValidation) {
      if (
        !this.filteredUnits ||
        !this.filteredUnits.find(unit => {
          return unit.id === control.value;
        })
      ) {
        control.setValue(null);
      }
    }
  }

  autoCompleteUnitChanged(ev: MatAutocompleteSelectedEvent, control: string) {
    this[control] = ev.option.value;
  }

  getCaseManagementReport(reportType: string) {
    this.loading = true;
    let selectedUnit: string;
    let startDate;
    let endDate;
    switch (reportType) {
      case 'CurrentCMCases':
        selectedUnit = this.selectedUnitCurrent;
        startDate = this.startDateCurrent;
        endDate = this.endDateCurrent;
        break;
      case 'HistoricalCMCases':
        selectedUnit = this.selectedUnitHistorical;
        startDate = this.startDateHistorical;
        endDate = this.endDateHistorical;
        break;
      case 'CMNotes':
        selectedUnit = this.selectedUnitNotes;
        startDate = this.startDateNotes;
        endDate = this.endDateNotes;
        break;
      case 'AutoApprovedCM':
        selectedUnit = this.selectedUnitAutoApproved;
        startDate = this.startDateAutoApproved;
        endDate = this.endDateAutoApproved;
        break;

      default:
        break;
    }

    const queryJson = {
      take: 25,
      skip: 0,
      search: {
        SavedTime: { start: startDate, end: endDate },
        unitID: { searchString: selectedUnit },
      },
      sort: {},
      name: reportType,
    };

    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);
    this.rptSvc.getCaseManagementReport(queryJson).subscribe({
      next: data => {
        const filename = `${selectedUnit}_${reportType}.xlsx`;
        let fileData;
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename, {
            proxyURL: `${this.baseUrl}/util/proxy`,
            proxyTarget: '_self',
            forceProxy: iosSafari,
          });
        };
        this.loading = false;
      },
      error: error => {
        this.loading = false;
        console.error(error);
        this.snacky.open(
          `There are no records available based on the current inputs. Please try again.`,
          'Close',
          {
            duration: 8000,
          }
        );
      },
    });
  }
}
